module.exports = __webpack_public_path__ + "static/media/figma.00484c2b.svg";